module.exports = __webpack_public_path__ + "img/test_image.c58c3f1c.jpeg";